import { arrayOf, bool, object, string } from 'prop-types';

import Tile from './Tile';

import style from './DailyTiles.module.scss';

export default function DailyTiles({
  lastClaimAt,
  dailyNotificationsEnabled,
  siteNotificationsEnabled,
  rewards,
  popupGradient,
}) {
  return (
    <div className={style.DailyTiles}>
      {rewards.map((reward, index) => (
        <Tile
          key={index}
          lastClaimAt={lastClaimAt}
          dailyNotificationsEnabled={dailyNotificationsEnabled}
          siteNotificationsEnabled={siteNotificationsEnabled}
          reward={reward}
          index={index}
          popupGradient={popupGradient}
        />
      ))}
    </div>
  );
}
DailyTiles.propTypes = {
  lastClaimAt: string,
  rewards: arrayOf(object),
  popupGradient: string.isRequired,
  dailyNotificationsEnabled: bool.isRequired,
  siteNotificationsEnabled: bool.isRequired,
};
